module.exports = __webpack_public_path__ + "img/png2.68b3e769.png";